export default function ApartmentTypesSection() {
  const types = [
    {
      icon: 'ri-home-4-fill',
      title: 'Duplexes & Triplexes',
      description: 'Small multi-family properties with 2-3 units',
      image: 'https://public.readdy.ai/ai/img_res/2e2b547e5a878a7a1673c1ae2c18a230.jpg'
    },
    {
      icon: 'ri-building-2-fill',
      title: 'Fourplexes & Small Complexes',
      description: 'Mid-sized properties with 4-12 units',
      image: 'https://readdy.ai/api/search-image?query=fourplex%20apartment%20building%20four%20unit%20multi%20family%20property%20residential%20investment%20real%20estate%20modern%20architecture%20well%20maintained%20clean%20simple%20background%20professional%20photography&width=600&height=400&seq=sellapttypes2&orientation=landscape'
    },
    {
      icon: 'ri-building-4-fill',
      title: 'Medium Apartment Buildings',
      description: 'Properties with 12-30 units',
      image: 'https://readdy.ai/api/search-image?query=medium%20size%20apartment%20building%20complex%20multi%20story%20residential%20property%20multiple%20units%20professional%20real%20estate%20investment%20property%20modern%20architecture%20clean%20simple%20background&width=600&height=400&seq=sellapttypes3&orientation=landscape'
    },
    {
      icon: 'ri-community-fill',
      title: 'Large Apartment Complexes',
      description: 'Major properties with 30+ units',
      image: 'https://readdy.ai/api/search-image?query=large%20apartment%20complex%20building%20multi%20story%20residential%20property%20many%20units%20professional%20commercial%20real%20estate%20investment%20modern%20architecture%20clean%20simple%20background%20urban%20development&width=600&height=400&seq=sellapttypes4&orientation=landscape'
    },
    {
      icon: 'ri-hotel-fill',
      title: 'Mixed-Use Properties',
      description: 'Buildings with retail and residential units',
      image: 'https://readdy.ai/api/search-image?query=mixed%20use%20building%20commercial%20retail%20ground%20floor%20residential%20apartments%20above%20urban%20property%20investment%20real%20estate%20modern%20architecture%20clean%20simple%20background%20professional%20photography&width=600&height=400&seq=sellapttypes5&orientation=landscape'
    },
    {
      icon: 'ri-ancient-gate-fill',
      title: 'Older Apartment Buildings',
      description: 'Properties needing renovation or updates',
      image: 'https://readdy.ai/api/search-image?query=older%20vintage%20apartment%20building%20needing%20renovation%20fixer%20upper%20multi%20family%20property%20investment%20opportunity%20real%20estate%20dated%20architecture%20clean%20simple%20background%20professional%20photography&width=600&height=400&seq=sellapttypes6&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Property Types
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Types of Apartments We Buy
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            As experienced apartment buyers, we purchase all types of multi-family properties throughout El Paso and West Texas. No property is too small or too large for our team.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {types.map((type, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={type.image}
                  alt={type.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center">
                    <i className={`${type.icon} text-white text-2xl`}></i>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{type.title}</h3>
                <p className="text-gray-600 leading-relaxed">{type.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-8 max-w-3xl mx-auto">
            Whether you own a small duplex or a large apartment complex, we have the experience and resources to make you a fair cash offer. We buy apartments in any condition, with tenants in place or vacant, and handle all the details through a trusted title company.
          </p>
          <div className="inline-flex items-center space-x-3 bg-teal-50 px-6 py-4 rounded-xl">
            <i className="ri-checkbox-circle-fill text-teal-600 text-2xl"></i>
            <span className="text-gray-700 font-semibold">All property types considered • Fast closings • Cash offers</span>
          </div>
        </div>
      </div>
    </section>
  );
}